import { safeSessionStorage } from '@toss/storage';

import type { CreateQuizPlanOrderRequest } from '@/api/gen/_model/createQuizPlanOrderRequest';
import type { PlanChangeOrderRequest } from '@/api/gen/_model/planChangeOrderRequest';
import type { TrialVoucherActivationTrackingContext } from '@/shared/features/trial-voucher/trialVoucherContext';

type PaymentResolutionContext =
  | { kind: 'order'; request: CreateQuizPlanOrderRequest }
  | { kind: 'plan-change'; request: PlanChangeOrderRequest }
  | {
      kind: 'attempt';
      quizPlanOrderHashId: string;
      providerCode?: string;
      paymentUrl: string;
    }
  | {
      kind: 'voucher';
      voucherHashId: string;
      trialTrackingContext?: TrialVoucherActivationTrackingContext;
    };

const keyFor = (orderId: string) => `quiz-payment-resolution:${orderId}`;

export const setPaymentResolutionContext = (
  orderId: string,
  context: PaymentResolutionContext,
) => {
  safeSessionStorage.set(keyFor(orderId), JSON.stringify(context));
};

export const getPaymentResolutionContext = (orderId: string) => {
  const stored = safeSessionStorage.get(keyFor(orderId));
  if (!stored) return undefined;

  try {
    const context = JSON.parse(stored) as PaymentResolutionContext;
    return ['order', 'plan-change', 'attempt', 'voucher'].includes(context.kind)
      ? context
      : undefined;
  } catch {
    return undefined;
  }
};

export const clearPaymentResolutionContext = (orderId: string) => {
  safeSessionStorage.remove(keyFor(orderId));
};

export type { PaymentResolutionContext };
